import Radio from "./Radio";

type RadioTypes = {
  id: string;
  name: string;
};

type AppProps = {
  optionsList: RadioTypes[];
  handleSetRadioValue: (id: string) => void;
  radioValue: string;
  alignment?: string;
  backGround?: boolean;
  schedulingFilterRadio?: boolean;
  diasableId?: string;
  disable?: boolean;
};

const RadioContainer = ({
  optionsList,
  handleSetRadioValue,
  radioValue,
  alignment,
  backGround,
  schedulingFilterRadio,
  diasableId,
  disable,
}: AppProps) => {
  const renderRadios = () => {
    const finalList = optionsList?.map((option) => {
      return (
        <Radio
          value={radioValue}
          onPress={handleSetRadioValue}
          alignment={alignment}
          data={option}
          key={option.id}
          backGround={backGround}
          schedulingFilterRadio={schedulingFilterRadio}
          diasableId={diasableId}
          disable={disable}
        />
      );
    });

    return finalList;
  };

  return (
    <div
      className={
        alignment === "vertical"
          ? "radio-list-container-vertical ml-1"
          : "radio-list-container-horizontal ml-2"
      }
    >
      {renderRadios()}
    </div>
  );
};

export default RadioContainer;
